import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtText from "../../../components/NtText";
import { useMobile } from "../../../hooks/useMobile";

function NtBusinessFeatureSection({}) {
  const isMobile = useMobile();
  const renderBox = (containerStyle, icon, title, subtitle) => {
    return (
      <View
        style={[
          { flex: 1, backgroundColor: "white", borderRadius: 10, padding: 20 },
          containerStyle,
        ]}
      >
        <NtMaterialIcon name={icon} color="#030305" size={30} />
        <NtText
          style={{
            marginTop: 15,
            color: "#030305",
            fontSize: 14,
            fontWeight: "600",
          }}
        >
          {title}
        </NtText>
        <NtText
          style={{
            marginTop: 8,
            color: "#5A5A5A",
            fontSize: 12,
            fontWeight: "300",
          }}
        >
          {subtitle}
        </NtText>
      </View>
    );
  };

  return (
    <NtMarketingSectionContainer
      style={[styles.container, isMobile ? { height: 750 } : {}]}
      backgroundImage={require("../../../assets/images/marketing/99dee143ce6d0dd4eb73d82b55b15ab8a692eed2.jpg")}
    >
      <NtSectionTitle style={{ marginTop: 60, textAlign: "left" }}>
        FEATURES
      </NtSectionTitle>
      <NtSectionDescription style={{ marginTop: 8 }}>
        A powerful suite of features including Ring Groups, Call Recording,
        Advanced Call Forwarding, and Extensions—designed to streamline
        communication, enhance flexibility, and boost business efficiency.
      </NtSectionDescription>

      <View
        style={{ flexDirection: isMobile ? "column" : "row", marginTop: 40 }}
      >
        {renderBox(
          { marginRight: isMobile ? 0 : 10, marginBottom: isMobile ? 10 : 0 },
          "account-group-outline",
          "Ring Group",
          "A Ring Group is a way for a group of extensions to share the distribution of incoming calls. Is a great way for a business to share the distribution of incoming calls among employees."
        )}

        {renderBox(
          { marginRight: isMobile ? 0 : 10, marginBottom: isMobile ? 10 : 0 },
          "microphone",
          "Call Recording",
          "Call recording software enables you to record telephone conversations either over a PSTN (Public Switched Telephone Network) or VoIP (Voice over IP) in a digital audio file format. It also provides you with the ability to retrieve, playback, store and share call recordings."
        )}

        {renderBox(
          {},
          "phone-missed",
          "Advanced Call Forwarding",
          "One Number Access (ONA) is an advanced call forwarding rule that allows inbound calls to be diverted to other phones in a specific order or sequentially."
        )}
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 600,
  },
});

export default NtBusinessFeatureSection;
